// ReSharper disable InconsistentNaming
import 'babel-polyfill';

import Vue from 'vue';
import VueRouter from 'vue-router';

import store from '../store';
import nprogress from 'nprogress';
import identityApi from '../api';

store.dispatch('identities/initializeIdentities');

Vue.use(VueRouter);
const routes = [
    {
        path: '/app',
        redirect: { name: 'login-chooser' }
    },
    {
        path: '/app/login',
        name: 'login-chooser',
        component: () =>
            import(
                /* webpackChunkName: "app.bundle" */
                '../components/Login/UserChooser.vue'),
        beforeEnter: (to, from, next) => {
            if (store.getters['identities/count'] > 0) {
                next();
            } else {
                next({ name: 'login-username' });
            }
        }
    },
    {
        path: '/app/samlChooser',
        name: 'saml-chooser',
        props: true,
        component: () =>
            import(
                /* webpackChunkName: "app.bundle" */
                '../components/Login/SamlChooser.vue'),
        beforeEnter: (to, from, next) => {
            if (to.params.providers && to.params.username) {
                next();
            } else {
                next({ name: 'login-chooser' });
            }
        }
    },
    {
        path: '/app/login/username',
        name: 'login-username',
        component: () =>
            import(
                /* webpackChunkName: "app.bundle" */
                '../components/Login/Username.vue'),
        beforeEnter: (to, from, next) => {
            next(vm => {
                vm.validation = [];
            });

        }
    },
    {
        path: '/app/login/password',
        name: 'login-password',
        component: () => import(
            /* webpackChunkName: "app.bundle" */
            '../components/Login/Password.vue'),
        props: true,
        beforeEnter: (to, from, next) => {
            if (to.params.selectedUsername) {
                next();
            } else {
                next({ name: 'login-chooser' });
            }
        },
        beforeLeave(to, from, next) {
            Object.assign(this.$data, this.$options.data());
            this.$refs.password.reset();
            this.error = false;
            next();
        }
    },
    {
        path: '/app/login/remove-user',
        name: 'chooser-remove',
        component: () => import(
            /* webpackChunkName: "app.bundle" */
            '../components/Login/RemoveUser.vue'),
        props: true
    },
    {
        path: '/app/profile/password',
        name: 'password-change',
        component: () =>
            import(
                /* webpackChunkName: "app.bundle" */
                '../components/ChangePassword.vue')
    },
    {
        path: '/app/password/forgot',
        name: 'password-forgot',
        component: () =>
            import(
                /* webpackChunkName: "app.bundle" */
                '../components/ForgotPassword.vue'),
        props: true
    },
    {
        path: '/app/password/reset',
        name: 'password-reset',
        component: () =>
            import(
                /* webpackChunkName: "app.bundle" */
                '../components/ResetPassword.vue'),
        props: route => route.meta.props,
        beforeEnter: (to, from, next) => {
            if (to.query.token) {
                identityApi.resetPassword.get({
                    params: {
                         token: to.query.token
                    },
                    verifyRequest: true
                })
                    .then(r => {
                        to.meta.props = r.data;
                        to.meta.props.resetToken = to.query.token;
                        next();
                    }).catch(error => {
                        const errorMessage = error.response.data.errors.map(e => e.message).join('</br>');
                        next({ name: 'password-forgot' });
                        store.commit('notifications/notify', { text: errorMessage, type: 'error', timeout: 0 });
                    });
            } else {
                next({ name: 'login-chooser' });
            }
        }
    },
    {
        path: '/app/activate',
        name: 'activate',
        component: () =>
            import(
                /* webpackChunkName: "app.bundle" */
                '../components/Activation/Activate.vue'
            ),
        props: route => route.meta.props
    },
    {
        path: '/app/emailResend',
        name: 'email-resend',
        component: () =>
            import(
                /* webpackChunkName: "app.bundle" */
                '../components/EmailResend.vue'
            ),
        props: true
    },
    {
        path: '/app/logout',
        name: 'logout',
        component: () =>
            import(
                /* webpackChunkName: "app.bundle" */
                '../components/Logout.vue'
            ),
        props: route => route.meta.props,
            beforeEnter: async(to, from, next) => {
        console.log('[index.js] Navigation started from index.js');
            const logoutId = to.query.logoutId;
            const showLogoutPrompt = String(to.query.showLogoutPrompt).toLowerCase() === 'true';
            const crossLogoutDone = String(to.query.crossLogoutDone).toLowerCase() === 'true';
            const backToApiDone = String(to.query.backToApiDone).toLowerCase() === 'true';
            
            // User wants confirmation page.
            // DO NOT logout here.
            if (showLogoutPrompt && !crossLogoutDone && !backToApiDone) {
                console.log('[index.js] Showing logout confirmation page');
            console.log('[index.js] Logout will NOT be performed yet');
                to.meta.props = {
                    logoutId: logoutId,
                    initialLoggedOut: false,
                    samlLogoutUrl: to.query.samlLogoutUrl
                };

                next();
                return;
            }
            
                const OLD_API_URL = window.APP_CONFIG.identityApi_OldUrls;
                const NEW_API_URL = window.APP_CONFIG.identityApi_NewUrls;
                const OLD_API_HOST = OLD_API_URL ? new URL(OLD_API_URL).hostname : null;
                const NEW_API_HOST = NEW_API_URL ? new URL(NEW_API_URL).hostname : null;
                const currentUrlHost = window.location.hostname;
                let otherApiUrl = null;

                if (currentUrlHost === OLD_API_HOST) {
                    otherApiUrl = NEW_API_URL;
                }
                else if (currentUrlHost === NEW_API_HOST) {
                    otherApiUrl = OLD_API_URL;
                }
                if (otherApiUrl && !crossLogoutDone && !backToApiDone) {
                    const redirectUrl =`${otherApiUrl}/auth/logout?logoutId=${logoutId}&showLogoutPrompt=False&crossLogoutDone=True`;
                     console.log('[index.js] STEP 1 : Redirecting to other API for cross logout');
                    console.log('[index.js] Redirect URL:', redirectUrl);
                    
                    window.location.href = redirectUrl;
                    return;
                }

                const logout = async logoutId => {
                const response = await identityApi.logout.post({
                    payload: { LogoutId: logoutId }
                });

                console.log('[index.js] Logout API response:', response);
                console.log('[index.js] Logout API response.data:', response.data);

                store.commit("logout/spLoggedOut", true);
                console.log('[index.js] spLoggedOut set to true');
                
                let samlLogoutUrl = to.query.samlLogoutUrl;
                if (crossLogoutDone && backToApiDone) {
                    to.meta.props = {
                        initialPostLogoutRedirectUri: response.data.postLogoutRedirectUri,
                        initialSignOutIframeUrl: response.data.signOutIframeUrl,
                        initialClientName: response.data.clientName,
                        initialLoggedOut: true
                    };
                    samlLogoutUrl = "";
                }
                else{
                    to.meta.props = {
                        initialPostLogoutRedirectUri: response.data.postLogoutRedirectUri,
                        initialSignOutIframeUrl: response.data.signOutIframeUrl,
                        initialClientName: response.data.clientName,
                        initialLoggedOut: true,
                        samlLogoutUrl: to.query.samlLogoutUrl
                    };
                }

                console.log('[index.js] meta.props after logout:', to.meta.props);
                next();
                console.log('[index.js] next() called');

                if (samlLogoutUrl) {
                    setTimeout(() => {
                        window.location = samlLogoutUrl;
                    }, 5000);
                }

                if (response.data.postLogoutRedirectUri) {
                    setTimeout(() => {
                        window.location = response.data.postLogoutRedirectUri;
                    }, 5000);
                }

                setTimeout(() => {
                    store.commit("logout/spLoggedOut", false);
                }, 5000);
            };

            if (to.query.showLogoutPrompt) {
                try {
                    if (JSON.parse(to.query.showLogoutPrompt.toLowerCase())) {
                        // we need to manually log out
                        to.meta.props = to.query;
                        next();
                    } else {
                        // automatically log out
                        await logout(to.query.logoutId);
                    }
                } catch (error) {
                    next({ name: 'login-chooser' });
                }
            } else {
                next({ name: 'login-chooser' });
            }
            
            if (otherApiUrl && crossLogoutDone && !backToApiDone) {
                const redirectUrl =`${otherApiUrl}/auth/logout?logoutId=${logoutId}&showLogoutPrompt=False&crossLogoutDone=True&backToApiDone=True`;
                
            console.log('[index.js] STEP 4 : Cross logout completed, returning to original API');

            console.log('[index.js] Return URL:', redirectUrl);

            window.location.href = redirectUrl;
                return;
            }
        
    }
},
    {
        path: '/app/signup',
        name: 'signup',
        component: () =>
            import(
                /* webpackChunkName: "app.bundle" */
                '../components/Signup.vue'
            ),
        beforeLeave: (to, from, next) => {
            this.$refs.form.reset();
            this.error = false;
            this.recaptchaResponse = null;

            next();
        }
    },
    {
        path: '/app/user/verify',
        name: 'import',
        component: () =>
            import(
                /* webpackChunkName: "app.bundle" */
                '../components/Import.vue'
            ),
        beforeLeave: (to, from, next) => {
            this.$refs.form.reset();
            this.error = false;
            next();
        }
    },
    {
        path: '*',
        component: () =>
            import(
                /* webpackChunkName: "app.bundle" */
                '../components/NotFound.vue'
            )
    }
];

const router = new VueRouter({
    mode: 'history',
    routes: routes
});

router.beforeResolve((to, from, next) => {
    if (to.name) {
        nprogress.start();
    }
    next();
});

router.afterEach(() => {
    nprogress.done();
});

export default router;
